<template>
  <div class="tag-list" v-if="tagList && tagList.length > 0">
    <ul>
      <li
        v-for="item in tagList"
        :key="item.id"
        @click="onSelectTag(item)"
        :class="{ selected: item.selected || isLook }"
      >
        {{ item.labelName }}
      </li>
    </ul>
  </div>
</template>
<script>
import mixins from './mixins'

export default {
  mixins: [mixins],
  props: {
    commentLabelList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    tagList() {
      return this.commentLabelList.map(item => {
        item.selected = !!item.selected
        return item
      })
    }
  },
  methods: {
    onSelectTag(item) {
      if (this.isLook) return
      item.selected = !item.selected
      this.$forceUpdate()
      this.$emit('onChangeTag', this.tagList)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.tag-list {
  width: 100%;
  padding-bottom: rem(32px);
  @include border(bottom, #e8e8e8, 1px);
  ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  li {
    margin-top: rem(20px);
    margin-right: rem(20px);
    height: rem(50px);
    padding: 0 rem(20px);
    font-size: rem(24px);
    color: #121212;
    line-height: rem(50px);
    border-radius: rem(50px);
    background: #f5f5f5;
    &.selected {
      background: #ffecf1;
      @include border(all, #ff397e, 1px, 0.5rem);
      color: #ff397e;
    }
  }
}
</style>
